import { FeedbackStatus } from "@/api";
import { OverridableStringUnion } from "@mui/types";
import { Avatar, Chip, ChipProps } from "@mui/material";
import { JSX } from "react";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import CheckIcon from "@mui/icons-material/Check";

interface IProps extends ChipProps {
    status: FeedbackStatus;
}

interface StatusStylesType {
    outlineColor: OverridableStringUnion<
        "success" | "info" | "error",
        ChipProps["color"]
    >;
    color: string;
    icon: JSX.Element;
}

export const StatusChip = ({ status, ...props }: IProps) => {
    const statusStylesMap: { [key in FeedbackStatus]: StatusStylesType } = {
        [FeedbackStatus.RESOLVED]: {
            outlineColor: "success",
            color: "success.main",
            icon: <CheckIcon fontSize="small" style={{ color: "white" }} />,
        },
        [FeedbackStatus.UNDER_REVIEW]: {
            outlineColor: "info",
            color: "info.main",
            icon: <InfoIcon fontSize="small" style={{ color: "white" }} />,
        },
        [FeedbackStatus.UNRESOLVED]: {
            outlineColor: "error",
            color: "error.main",
            icon: <WarningIcon fontSize="small" style={{ color: "white" }} />,
        },
    };

    return (
        <Chip
            variant="outlined"
            color={statusStylesMap[status].outlineColor}
            avatar={
                <Avatar sx={{ bgcolor: statusStylesMap[status].color }}>
                    {statusStylesMap[status].icon}
                </Avatar>
            }
            label={status}
            {...props}
        />
    );
};
